import { NgModule } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

import { AllowSpecialCharacterDirective, OnlyAbcdCharacterDirective } from "@core/directives/utilities-directive/no-char-special.directive";
import { CapsLockDirective } from "@core/directives/utilities-directive/caps-lock.directive";
import { NoSpaceDirective } from "@core/directives/utilities-directive/no-space.directive";
import { ThousandsSeparatorDirective } from '@core/directives/utilities-directive/thousands-separator.directive';
import { SwitchCasesDirective } from '@core/directives/utilities-directive/mq-switch.directive';
import { LimitIntegerLengthDirective } from '@core/directives/utilities-directive/ limit-integer-length.directive';
@NgModule({
  declarations: [AllowSpecialCharacterDirective, OnlyAbcdCharacterDirective, CapsLockDirective, NoSpaceDirective, ThousandsSeparatorDirective, SwitchCasesDirective, LimitIntegerLengthDirective],
  exports: [AllowSpecialCharacterDirective, OnlyAbcdCharacterDirective, CapsLockDirective, NoSpaceDirective, ThousandsSeparatorDirective, SwitchCasesDirective, LimitIntegerLengthDirective],
  providers: [CurrencyPipe, DecimalPipe]
})
export class UtilitiesDirectiveModule { }
